<app-header-dropdown
  [items]="dsos$"
  [buttonToggleText]="'Meine DSO'"
  (itemSelected)="dsoSelected($event)"
  (searchTermChanged)="searchTermChanged($event)"
></app-header-dropdown>
